var _ = require('lodash');

module.exports = {

  _storeEventsUnRegistry: null,

  _addStoreListeners: function () {

    var listenersToAttach = {};
    var onStoreChanged = _.debounce(this.onStoreChanged.bind(this), 10);

    // list of listeners to attach
    listenersToAttach[this.Store.Events.Changed] = onStoreChanged;
    listenersToAttach[this.Store.Events.ChangedEditableTypes] = this.onStoreChangedEditableTypes.bind(this);

    // setup the event registry so we can remove listeners easily
    this._storeEventsUnRegistry = this._storeEventsUnRegistry || this._newUnregisterEventsRegistry();

    // Increment maxlisteners
    this.Store.setMaxListeners((this.Store._maxListeners || 5) + 1);

    _.forEach(listenersToAttach, function (handler, eventname) {
      var unregFn = this.Store.on(eventname, handler);
      this._storeEventsUnRegistry.add(unregFn);
    }.bind(this));
  },

  _removeStoreListeners: function () {
    var maxListeners = this.Store._maxListeners - 1;
    maxListeners = maxListeners > 5 && maxListeners || 5;

    this.Store.setMaxListeners(maxListeners);
    this._storeEventsUnRegistry.run();
  },

  onStoreChanged: function () {
    var _this = this;
    var activeLayer = this.Store.get('activeLayer');
    var activeLayerPopupOpen = this.Store.get('activeLayerPopupOpen');
    var activeLayerPopupContent = this.Store.get('activeLayerPopupContent');

    // check to see if the layer should be active BEFORE doing popup state
    changeActiveState(activeLayer);
    changePopupState(activeLayerPopupOpen, activeLayerPopupContent);

    function changeActiveState (activeLayer) {

      // A layer should be active... check to see if it is this one
      if (activeLayer) {
        if (!isSameLayer(activeLayer, _this.layer)) {
          _this.setInactive();
          _this.disableEditing();
        } else if (isSameLayer(activeLayer, _this.layer) && !_this.isActive) {
          _this.setActive();
          _this.enableEditing();
        }

      }
      // No layer should be active
      else {
        _this.setInactive();
        _this.disableEditing();
      }
    }

    function changePopupState (open, content) {
      if (_this.isActive) {
        if (!_this.isPopupOpen && open) {
          // open the popup
          _this.showPopup();
        } else if (_this.isPopupOpen && !open) {
          // close the popup
          //
          // NOTE this event is triggered by the Store via an external application event. We are assuming
          // that if the application tells us to close the popup that it is always explicitly wanted by the user
          _this.popupClosedByUser = true;
          _this.hidePopup(true);
        }
      } else {
        _this.hidePopup();
      }
    }

    function isSameLayer (layer1, layer2) {
      if (layer1.$$layerUID !== undefined &&
          layer2.$$layerUID !== undefined) {
        return layer1.$$layerUID === layer2.$$layerUID;
      } else if (layer1.id !== undefined &&
          layer2.id !== undefined) {
        // All layers should have a type now...
        if (layer1.type && layer2.type) {
          return layer1.id === layer2.id && layer1.type === layer2.type;
        } else {
          // But just in case they don't...
          console.warn('Layer is missing a type property. Is this intentional?');
          return layer1.id === layer2.id;
        }
      } else {
        return false;
      }
    }
  },

  onStoreChangedEditableTypes: function () {
    var types = this.Store.get('editableTypes');
    this.toggleEditable();
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/base/mixins/StoreMixin.js